function buuntoCustom() {
    let currentAnchor = "productPage"

    function getProductPageAnchor() {
        return document.querySelector("#buunto-product-anchor")
    }
    
    function getModalAchor() {
        const element = document.querySelector("#buunto-modal-anchor")
        if (element) return element
        const newAnchor = document.createElement("div")
        newAnchor.id = "buunto-modal-anchor"
        const consentCheckboxField = document.querySelector(".pp-field-sticky")?.previousElementSibling
        if (!consentCheckboxField) return
        consentCheckboxField.insertAdjacentElement("beforebegin", newAnchor, consentCheckboxField)
        return newAnchor
    }
    
    function switchToModal() {
        if (currentAnchor === "modal") return
        currentAnchor = "modal"
        
        // Remove widget from product page
        const productPageAnchor = getProductPageAnchor()
        if (!productPageAnchor) return
        productPageAnchor.innerHTML = ""

        // Add widget to modal
        const modalAnchor = getModalAchor()
        if (!modalAnchor) return
        getModalAchor().innerHTML = "<div id='buunto-date-picker'></div>"
    }

    function switchToProductPage() {
        if (currentAnchor === "productPage") return
        currentAnchor = "productPage"
        
        // Remove widget from modal
        const modalAnchor = getModalAchor()
        if (!modalAnchor) return
        modalAnchor.innerHTML = ""

        // Add widget to product page
        const productPageAnchor = getProductPageAnchor()
        if (!productPageAnchor) return
        productPageAnchor.innerHTML = "<div id='buunto-date-picker'></div>"
    }

    function waitAndGetModal() {
        return new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                const modal = document.querySelector(".pp-modal")
                if (modal) {
                    clearInterval(interval)
                    resolve(modal)
                }
            }, 100)
        })
    }

    async function init() {
        const ppModal = await waitAndGetModal()
        if (!ppModal) return
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (!mutation?.target?.classList) return
                if (mutation.target.classList.contains("modal--is-active")) {
                    switchToModal()
                } else {
                    switchToProductPage()
                }
            })
        })
        observer.observe(ppModal, { attributes: true })
    }

    init()
}

buuntoCustom()